import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { DataDispatchChannelEnum } from '../../../shared/modules/data-dispatch/enums/data-dispatch-channel.enum';
import { OutboxStatusEnum } from '../enums/outbox-status.enum';
import { OutboxTypeEnum } from '../enums/outbox-type.enum';

/**
 * Outbox DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.OUTBOX)
export class OutboxSearchDto extends BaseSearchDto {
	tenantId!: number;
	userId!: number;
	type!: OutboxTypeEnum;
	channel?: DataDispatchChannelEnum;
	status!: OutboxStatusEnum;
	key!: string;
	subject!: AppSubjectEnum;
	subjectId!: number;
	dispatchToken!: string;
	retryCount!: number;
	nextRetryAt?: Date;
	scheduledAt?: Date;
	leasedBy?: string;
	leasedUntil?: Date;
	dispatchedAt?: Date;
	dispatchError?: string;

	displayValue(): string | null {
		return null;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string {
		return `${this.status}`;
	}
}
